import React from 'react';
import { BG } from '../lib/tokens';
import { useBreakpoint } from '../lib/useBreakpoint';

// Three visual modes, all driven by `useBreakpoint`:
//   - 'mobile'  → full viewport, no frame (original phone-first look)
//   - 'tablet'  → centered single column at max-width 640, no frame, on a dark page
//   - 'desktop' is handled upstream by DesktopShell — this component isn't used.
//
// We keep the public API the same (just renders children inside a container)
// so screens don't need to know which mode they're in.

export default function PhoneShell({ children }) {
  const bp = useBreakpoint();

  if (bp === 'mobile') {
    return (
      <div
        style={{
          width: '100vw',
          height: '100dvh',
          background: BG,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        {children}
      </div>
    );
  }

  // Tablet: dark page with a single, centered column. Bottom tabs still live
  // inside this column.
  return (
    <div
      style={{
        width: '100vw',
        minHeight: '100dvh',
        background: '#0d1220',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 640,
          height: '100dvh',
          background: BG,
          overflow: 'hidden',
          position: 'relative',
          boxShadow: '0 0 80px rgba(0,0,0,0.4)',
        }}
      >
        {children}
      </div>
    </div>
  );
}
